
    import { mapGetters } from 'vuex';
    import C1Tag from '@/C1Components/C1Tag.vue';

    export default {
        name: 'CompanyPerks',

        components: {
            C1Tag,
        },

        computed: {
            ...mapGetters('search', {
                $_companyPerks: 'companyPerks',
            }),
        },
    };
